// extracted by mini-css-extract-plugin
module.exports = {"img":"CarouselSectionSlideImage_img__h_YTx"};